import { Badge } from "@/components/ui/Badge";
import { cn } from "@/lib/utils";
import React from "react";
import { useTranslation } from "react-i18next";
import { Interest } from "@/__generated__/types";
import { InterestPill } from "@/components/InterestPill";

export const StudentInterestBadge = ({
  interests,
  maxInterests = 4,
  className,
}: {
  interests: Partial<Interest>[] | null;
  maxInterests?: number;
  className?: string;
}) => {
  const { t } = useTranslation();

  if (!interests || !interests.length) {
    return (
      <>
        <Badge
          variant="outline"
          className="rounded-full px-[11px] py-[3px] text-xs text-muted-foreground"
        >
          {t("studentCard.noInterests")}
        </Badge>
      </>
    );
  }

  return (
    <div className={cn("mt-2 flex flex-wrap gap-x-1 gap-y-2", className)}>
      {interests.slice(0, maxInterests).map((interest) => (
        <InterestPill key={interest.id} label={interest.name ?? ""} />
      ))}
      {interests.length > maxInterests && (
        <Badge
          variant="outline"
          className="rounded-full px-[11px] py-[3px] text-xs font-medium text-foreground"
        >
          +{interests.length - maxInterests}
        </Badge>
      )}
    </div>
  );
};
